import React, { useEffect, useState } from "react";
import { Modal, Input, Select, Button, Form, notification, Radio, Row, Col } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import PopupUI from "../Elements/PopupUI";
import { CONFIGURATION_CONVERTER, CONFIGURATION_METER } from "../../Common/Constants";
import { useStoreUpdaterWithAPI } from "../../Hooks/UseStoreUpdaterWithApi";
import { useSelector } from "react-redux";


const MeterPopupContent = ({
  onClose,
  isAdd,
 
  form,
}) => {
  const { makeRequest } = useStoreUpdaterWithAPI();
  const location = useLocation();

 
  


  const handleClear = () => {
    form.resetFields();
  };

  const handleNotification = (msg) => {
    notification.open({
      message: `${msg}`,
    });
  };

  useEffect(() => {
    if (isAdd) {
      form.resetFields();
    }
  }, [isAdd, form]);

  const handleAddFormChange = (changedValues, allValues) => {
    console.log(allValues)
    setAddFormData(allValues);
  };

  const handleAddFormSubmit = async () => {
    try {
      const formData = {
       
      };
     
      
      handleNotification("Successfully Saved");
      handleClear();
      onClose();
    } catch (err) {
      console.error(err);
    }
  };

 

  const modeselect = useSelector((state) => state.darkMode);

  const { isdarkMode } = modeselect;

  return (
    

    <Form
    form={form}
    onFinish={handleAddFormSubmit}
    name="add-group-form"
    className="font-bold w-[600px]"
    layout="vertical"
    onValuesChange={handleAddFormChange}
    initialValues={{}}
  >
    <Row gutter={16}>
      <Col span={8}>
        <Form.Item
          label="Meter ID"
          name="MeterID"
          rules={[{ required: true, message: "Please select meter ID" }]}
        >
          <Select
            className={`${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}`}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}
          >
            {/* {groupModuleList?.map(item => (
              <Select.Option key={item?.moduleID} value={item?.moduleID}>
                {item?.moduleName}
              </Select.Option>
            ))} */}
          </Select>
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="Meter Name"
          name="MeterName"
          rules={[{ required: true, message: "Please select meter name" }]}
        >
          <Select
            className={`${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}`}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}
          >
            {/* {groupModuleList?.map(item => (
              <Select.Option key={item?.moduleID} value={item?.moduleID}>
                {item?.moduleName}
              </Select.Option>
            ))} */}
          </Select>
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="Port No"
          name="PortNo"
          rules={[{ required: true, message: "Please select port number" }]}
        >
          <Select
            className={`${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}`}
            dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
          >
            {/* {reportStatusList?.map(item => (
              <Select.Option key={item?.reportStatusID} value={item?.reportStatusID}>
                {item?.reportStatusName === "Yes" ? "Allow" : "Not Allow"}
              </Select.Option>
            ))} */}
          </Select>
        </Form.Item>
      </Col>
    </Row>
  
    <Row gutter={16}>
      <Col span={8}>
        <Form.Item
          label="Meter Model"
          name="MeterModel"
          rules={[{ required: true, message: "Please select meter model" }]}
        >
          <Select
            className={`${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}`}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}
          >
            {/* {groupModuleList?.map(item => (
              <Select.Option key={item?.moduleID} value={item?.moduleID}>
                {item?.moduleName}
              </Select.Option>
            ))} */}
          </Select>
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="Meter Supplier"
          name="MeterSupplier"
          rules={[{ required: true, message: "Please select meter supplier" }]}
        >
          <Select
            className={`${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}`}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}
          >
            {/* {groupModuleList?.map(item => (
              <Select.Option key={item?.moduleID} value={item?.moduleID}>
                {item?.moduleName}
              </Select.Option>
            ))} */}
          </Select>
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="LanConverter"
          name="LanConverterName"
          rules={[{ required: true, message: "Please select LanConverter name" }]}
        >
          <Select
            className={`${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}`}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}
          >
            {/* {groupModuleList?.map(item => (
              <Select.Option key={item?.moduleID} value={item?.moduleID}>
                {item?.moduleName}
              </Select.Option>
            ))} */}
          </Select>
        </Form.Item>
      </Col>
    </Row>
  
    <Row gutter={16}>
      <Col span={8}>
        <Form.Item
          label="Category Name"
          name="CategoryName"
          rules={[{ required: true, message: "Please select category name" }]}
        >
          <Select
            className={`${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}`}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}
          >
            {/* {groupModuleList?.map(item => (
              <Select.Option key={item?.moduleID} value={item?.moduleID}>
                {item?.moduleName}
              </Select.Option>
            ))} */}
          </Select>
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="Starting Address"
          name="StartingAddress"
          rules={[{ required: true, message: "Please select starting address" }]}
        >
          <Select
            className={`${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}`}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}
          >
            {/* {groupModuleList?.map(item => (
              <Select.Option key={item?.moduleID} value={item?.moduleID}>
                {item?.moduleName}
              </Select.Option>
            ))} */}
          </Select>
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="No Of Registers"
          name="NoOfRegisters"
          rules={[{ required: true, message: "Please select number of registers" }]}
        >
          <Select
            className={`${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}`}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}
          >
            {/* {groupModuleList?.map(item => (
              <Select.Option key={item?.moduleID} value={item?.moduleID}>
                {item?.moduleName}
              </Select.Option>
            ))} */}
          </Select>
        </Form.Item>
      </Col>
    </Row>
  
    <Row gutter={16}>
      <Col span={8}>
        <Form.Item
          label="Baud rate"
          name="BaudRate"
          rules={[{ required: true, message: "Please select baud rate" }]}
        >
          <Select
            className={`${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}`}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}
          >
            {/* {groupModuleList?.map(item => (
              <Select.Option key={item?.moduleID} value={item?.moduleID}>
                {item?.moduleName}
              </Select.Option>
            ))} */}
          </Select>
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="Meter Location"
          name="MeterLocation"
          rules={[{ required: true, message: "Please select meter location" }]}
        >
          <Select
            className={`${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}`}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}
          >
            {/* {groupModuleList?.map(item => (
              <Select.Option key={item?.moduleID} value={item?.moduleID}>
                {item?.moduleName}
              </Select.Option>
            ))} */}
          </Select>
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="Active"
          name="Active"
          rules={[{ required: true, message: "Please select an option" }]}
        >
          <Radio.Group>
            <Radio value="yes">Yes</Radio>
            <Radio value="no">No</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>
    </Row>

    <Row gutter={16}>
      <Col span={8}>
        <Form.Item
          label="Modules"
          name="Modules"
          rules={[{ required: true, message: "Please select Modue" }]}
        >
          <Select
            className={`${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}`}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}
          >
            {/* {groupModuleList?.map(item => (
              <Select.Option key={item?.moduleID} value={item?.moduleID}>
                {item?.moduleName}
              </Select.Option>
            ))} */}
          </Select>
        </Form.Item>
      </Col>

    </Row>
  
    <Form.Item className="flex justify-end">
      <Button htmlType="submit" className="blue-btn mr-2">
        Save
      </Button>
      <Button className="blue-btn" onClick={handleClear}>
        Clear
      </Button>
    </Form.Item>
  </Form>
    

            ) 
};

const MeterPopup = ({
  isAdd,
  setIsAdd,
  isUpdate,
  setIsUpdate,
  fetchFlowGroupList,
  updateRecord,
  flowGroupList,
  title,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();

  // console.log(updateRecord);
  useEffect(() => {
    if (location.pathname === `${CONFIGURATION_METER}/meter-add-popup`) {
      setIsAdd(true);
     
      form.resetFields();
    }else {
      setIsAdd(false);
    
    }
  }, [location.pathname, form]);

  const handleClose = () => {
    setIsAdd(false);

    navigate(`${CONFIGURATION_METER}`);
    form.resetFields();
  };

  return (
    <>

        <PopupUI
       
          popupContent={
            <MeterPopupContent
              onClose={handleClose}
              isAdd={isAdd}
              isUpdate={isUpdate}
              
              form={form}
             
              hasModal={true}
              title={title}
            />
          }
          key={updateRecord?.groupID}
          isAdd={isAdd}
         
          setIsUpdate={setIsUpdate}
          handleClose={handleClose}
          
          isOpen={isUpdate || isAdd}
         
          hasModal={true}
          title={title}
        />
      
    </>
  );
};

export default MeterPopup;
